module.exports = __webpack_public_path__ + "static/media/0.9643d5e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/head/0.png
// module id = 131
// module chunks = 0